var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33317 1.51362V4.26732C9.33317 4.64069 9.33317 4.82737 9.40583 4.96998C9.46975 5.09542 9.57173 5.19741 9.69718 5.26132C9.83978 5.33398 10.0265 5.33398 10.3998 5.33398H13.1535M13.3332 6.65947V11.4673C13.3332 12.5874 13.3332 13.1475 13.1152 13.5753C12.9234 13.9516 12.6175 14.2576 12.2412 14.4493C11.8133 14.6673 11.2533 14.6673 10.1332 14.6673H5.8665C4.7464 14.6673 4.18635 14.6673 3.75852 14.4493C3.3822 14.2576 3.07624 13.9516 2.88449 13.5753C2.6665 13.1475 2.6665 12.5874 2.6665 11.4673V4.53398C2.6665 3.41388 2.6665 2.85383 2.88449 2.426C3.07624 2.04968 3.3822 1.74372 3.75852 1.55197C4.18635 1.33398 4.7464 1.33398 5.8665 1.33398H8.00769C8.49687 1.33398 8.74146 1.33398 8.97163 1.38924C9.17571 1.43824 9.3708 1.51905 9.54974 1.6287C9.75157 1.75239 9.92453 1.92534 10.2704 2.27124L12.3959 4.39673C12.7418 4.74263 12.9148 4.91558 13.0385 5.11741C13.1481 5.29636 13.2289 5.49145 13.2779 5.69552C13.3332 5.9257 13.3332 6.17029 13.3332 6.65947Z",
    stroke: "#DC6803",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileYellow);
export default __webpack_public_path__ + "static/media/file-yellow.e9927448aa15d69d34dbf26ac533541b.svg";
export { ForwardRef as ReactComponent };